import AppConstants from '../constants/AppConstants';
import AppDispatcher from '../dispatcher/AppDispatcher';

import { processSessionCOPCheck } from '../utils/COPUtils';

const AppActions = {
  /**
   * Log that an API call has begun.
   *
   * @param  {String} url
   */
  trackApiCallStarted(url) {
    AppDispatcher.handleViewAction({
      actionType: AppConstants.TRACK_API_CALL_STARTED,
      data: { url },
    });
  },

  /**
   * Log that an API call has finished.
   *
   * @param  {String} url
   */
  trackApiCallComplete(url) {
    AppDispatcher.handleViewAction({
      actionType: AppConstants.TRACK_API_CALL_COMPLETE,
      data: { url },
    });
  },
  /*
		Action to clear stores on user logout
  */
  logoutUser() {
    AppDispatcher.handleViewAction({
      actionType: AppConstants.LOGOUT_USER,
    });
  },

  /**
   * Get current session COP checks
   */
  getSessionCOPChecks() {
    AppDispatcher.handleViewAction({
      actionType: AppConstants.GET_SESSION_COP_CHECKS,
    });
  },

  /**
   * Set current session COP checks
   *
   * @param  {Object} scanDetails       containing sortCode and accountNumber properties
   * @param  {Boolean} resetThisKey     determines whether we are incrementing or removing an entry
   * @param  {Object} sessionCOPChecks  current session COP checks
   */
  setSessionCOPChecks(scanDetails, resetThisKey, sessionCOPChecks) {
    const newSessionCOPChecks = processSessionCOPCheck(
      scanDetails,
      resetThisKey,
      sessionCOPChecks
    );
    AppDispatcher.handleViewAction({
      actionType: AppConstants.SET_SESSION_COP_CHECKS,
      data: newSessionCOPChecks,
    });
  },
};

export default AppActions;
